import React, { useState } from 'react';

export const FileDropZone = ({ onDropFiles, children, className = '' }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files?.length) {
      onDropFiles(e.dataTransfer.files);
    }
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`rounded-md border-2 border-dashed p-2 transition-colors ${
        isDragging ? 'border-orange-500 bg-orange-500/10' : 'border-transparent'
      } ${className}`}
    >
      {children}
    </div>
  );
};
